import { Select } from "antd";
import moment from "moment";
import { useDispatch } from "react-redux";
import advances from "../../assets/icons/new_dash/advances.png";
import reports from "../../assets/icons/new_dash/reports.png";
import up from "../../assets/icons/new_dash/up.png";
import down from "../../assets/icons/new_dash/down.png";

import LineGraph from "../Analytics/LineArea";
import {
  Dashboard,
  dashboard as dashboardCall,
} from "../../actions/dashboard/dashboard";
import BaseCurrency from "../Common/BaseCurrency";
import { millify } from "../../config/helper";
// import Base from "antd/lib/typography/Base";

const TopSec = ({ dashboard }) => {
  const dispatch = useDispatch();
  return (
    <div className="mt1 d-flex">
      <div className="graph-sec mr1 card d-flex">
        <div className="left-sec w20">
          <div>
            <label>SPENDS THIS MONTH</label>
            <span>
              <BaseCurrency />{" "}
              {dashboard?.present_month_spend &&
                millify(
                  Object.values(dashboard?.present_month_spend)?.[0]
                )}
            </span>
          </div>
          <div className="mt2">
            <label>CHANGE FROM LAST MONTH SO FAR</label>
            <span className={dashboard?.change_from_last_month > 0 ? "up" : "down"}>
              <span className="ellipsis" title={millify(dashboard?.change_from_last_month) + "%"}>{millify(dashboard?.change_from_last_month)}%{" "}</span>
              <img src={dashboard?.change_from_last_month > 0 ? up : down} alt="" />
            </span>
            {/* <span className="last">- so far</span> */}
          </div>
          {/* <div>
            <label>PROJECTED SPEND</label>
            <span className="down">
              - <img src={down} alt="" />
            </span>
            <span className="last">- so far</span>
          </div> */}
        </div>
        <div className="right-sec w80">
          <div className="title">
            <span>Spend Summary</span>
            <Select
              options={[
                { label: "This Financial Year", value: "year" },
                { label: "This Quarter", value: "quarter" },
              ]}
              placeholder="Select timeline"
              onChange={(e) => {
                dispatch(dashboardCall({ period: e }));
                dispatch({
                  type: Dashboard.RESET,
                  payload: "first",
                });
              }}
            />
          </div>
          <div style={{ width: '100%', maxWidth: '620px', height: 'auto' }}>
            {dashboard?.spend_summary_graph && (
              <LineGraph
                id={"lineAreaGraph"}
                data={
                  dashboard?.spend_summary_graph
                    ? Object.keys(dashboard?.spend_summary_graph).map(
                      (ele) => ({
                        day: moment(ele, "MMM YYYY").format("MMM YY"),
                        label: ele,
                        txnValue: dashboard?.spend_summary_graph?.[ele],
                      })
                    )
                    : []
                }
              />
            )}
          </div>
        </div>
      </div>
      <div className="right-sec">
        <div className="reports">
          <div className="left-sec">
            <img src={reports} alt="" />
            <label>Reports</label>
            <span><BaseCurrency />{millify(dashboard?.total_report_amount)}</span>
          </div>
          <div className="right-sec">
            <div>
              <span>Pending Approval</span>
              <span>
                <BaseCurrency />{millify(dashboard?.total_pending_approved_amount)}
              </span>
            </div>
            <div>
              <span>Unreported Expenses</span>
              <span><BaseCurrency />{millify(dashboard?.unreported_expenses)}</span>
            </div>
            <div>
              <span>Pending Reimbursement</span>
              <span>
                <BaseCurrency />{millify(dashboard?.total_pending_reimbursement_amount)}
              </span>
            </div>
          </div>
        </div>
        <div className="reports">
          <div className="left-sec">
            <img src={advances} alt="" />
            <label>Advances</label>
            <span> <BaseCurrency />{millify(dashboard?.total_advance_amount)}</span>
          </div>
          <div className="right-sec">
            <div>
              <span>Pending Approval</span>
              <span>
                {" "}
                <BaseCurrency />
                {millify(dashboard?.total_advance_pending_approved_amount)}
              </span>
            </div>
            <div>
              <span>Approved</span>
              <span>
                {" "}
                <BaseCurrency />{millify(dashboard?.total_advance_approved_amount)}
              </span>
            </div>
            <div>
              <span>Recovered</span>
              <span>
                {" "}
                <BaseCurrency />{millify(dashboard?.total_advance_recovered_amount)}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TopSec;
